import { notificationError } from '../../../../../components/Notifications/callNotifcation';
import { useAppDispatch } from '../../../../../shared/libs/redux';
import { workshopModuleTagGroupApi } from '../../../../../entities/module/tag-group/workshop-module-tag-group';

export const useUnbindTagsFromGroup = () => {
	const dispatch = useAppDispatch();
	const [unbindTag] = workshopModuleTagGroupApi.useUnbindMutation();

	const unbindTagsFromGroup = async (groupId: string, tags: number[]) => {
		try {
			await unbindTag({ groupId, tags }).unwrap();
			dispatch(workshopModuleTagGroupApi.util?.invalidateTags(['workshopTagGroup']));
			dispatch(workshopModuleTagGroupApi.util?.invalidateTags(['workshopTagGroup']));
		} catch (err) {
			notificationError('Произошла ошибка при привязке тега к группе...');
			throw err;
		}
	};

	return { unbindTagsFromGroup };
};
